/** Mockup nav — scroll state, mobile menu, cart count sync. */
(function () {
  const nav = document.querySelector('[data-zm-nav]');
  const burger = document.querySelector('[data-zm-burger]');
  const panel = document.querySelector('[data-zm-mobile-panel]');
  const cartCount = document.querySelector('[data-cart-count]');

  if (nav) {
    window.addEventListener(
      'scroll',
      () => nav.classList.toggle('is-scrolled', window.scrollY > 8),
      { passive: true }
    );
  }

  if (burger && panel && nav) {
    const setPanelTop = () => {
      const top = Math.ceil(nav.getBoundingClientRect().bottom);
      panel.style.top = `${top}px`;
    };

    const setOpen = (open) => {
      panel.classList.toggle('is-open', open);
      burger.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.documentElement.classList.toggle('zm-menu-open', open);
      if (open) setPanelTop();
    };

    setPanelTop();
    setOpen(false);

    burger.addEventListener('click', () => {
      setOpen(!panel.classList.contains('is-open'));
    });

    panel.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', () => setOpen(false));
    });

    window.addEventListener(
      'resize',
      () => {
        if (panel.classList.contains('is-open')) setPanelTop();
      },
      { passive: true }
    );

    window.addEventListener(
      'scroll',
      () => {
        if (panel.classList.contains('is-open')) setPanelTop();
      },
      { passive: true }
    );

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) {
        setOpen(false);
        burger.focus();
      }
    });
  }

  async function refreshCartCount() {
    if (!cartCount) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      cartCount.textContent = cart.item_count;
      cartCount.classList.toggle('is-visible', cart.item_count > 0);
    } catch (_) {
      /* ignore */
    }
  }

  document.addEventListener('cart:refresh', refreshCartCount);
  refreshCartCount();
})();
